exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-lastpass-icon-root]{display:none!important}", ""]);

// exports
